import { BinInfo } from "../staticInfo/state";
import { EnquiryFormInfoAction } from "./action";
import { EnquiryFormInfoState, enquiryFormInfoState } from "./state";
import moment from "moment";

export function EnquiryFormInfoReducer(
    state: EnquiryFormInfoState = enquiryFormInfoState,
    action: EnquiryFormInfoAction
): EnquiryFormInfoState {
    switch (action.type) {
        case "@@enquiryFormInfoState/ChangeIsOverfilledAction":
            return {
                ...state,
                is_overfilled: action.is_overfilled,
                need_inspection: "1",
            };

        case "@@enquiryFormInfoState/ChangeIsOthersAction":
            return {
                ...state,
                is_others: action.is_others,
            };

        case "@@enquiryFormInfoState/ChangeDistrictAction":
            return {
                ...state,
                district_id: action.value,
                area_id: action.area_id,
            };
        case "@@enquiryFormInfoState/ChangeFileListAction":
            return {
                ...state,
                fileList: action.fileList,
            };

        case "@@enquiryFormInfoState/ChangeDateTimeAction":
            return {
                ...state,
                selectDate: action.date,
            };
        case "@@enquiryFormInfoState/ChangeEnquiryTypeAction":
            return {
                ...state,
                selectEnquiry_type_id: action.enquiry_type_id,
            };

        case "@@enquiryFormInfoState/ChangeCaseNoAction":
            return {
                ...state,
                case_no: action.case_no,
            };
        case "@@enquiryFormInfoState/SelectBinAction":
            return {
                ...state,
                binInfo: action.binInfo,
                district_id:action.binInfo?.district_id?action.binInfo?.district_id?.toString():'',
                area_id:action.binInfo?.area_id? action.binInfo.area_id.toString():''
                
            };
        case "@@enquiryFormInfoState/OthersRemarkAction":
            return {
                ...state,
                othersRemark: action.remark,
            };
        case "@@enquiryFormInfoState/InitEnquiryListAction":
            return {
                ...state,
                EnquiryList: action.enquiryList,
            };

        case "@@enquiryFormInfoState/ChnageNeedInspectionAction":
            return {
                ...state,
                need_inspection: action.need_inspection,
            };

        case "@@enquiryFormInfoState/InitSelectedEnquiryDataAction":
            const binInfo: BinInfo = {
                label: action.EnquiryList.bin_full_name,
                value: action.EnquiryList.bin_id,
                district_id: action.EnquiryList.district_id,
            };
            let fileData: any = [];

            if (action.EnquiryList.image && action.EnquiryList.image_thumb) {
                fileData.push({
                    image: action.EnquiryList.image,
                    image_thumb: action.EnquiryList.image_thumb,
                });
            }

            return {
                ...state,
                selectedEnquiry: true,
                selectDate: moment.utc(action.EnquiryList.enquiry_date),
                selectEnquiry_type_id:
                    action.EnquiryList.enquiry_type_id.toString(),
                case_no: action.EnquiryList.case_no,
                district_id: action.EnquiryList.district_id.toString(),
                binInfo: binInfo,
                is_others: action.EnquiryList.is_others === 0 ? false : true,
                is_overfilled:
                    action.EnquiryList.is_overfilled === 0 ? false : true,
                othersRemark: action.EnquiryList.others_remarks
                    ? action.EnquiryList.others_remarks
                    : "",
                need_inspection: action.EnquiryList.need_inspection.toString(),
                is_inspected:
                    action.EnquiryList.is_inspected?.toString() || null,
                handle_date:
                    moment.utc(action.EnquiryList.cs_handle_date) || null,
                result: action.EnquiryList.cs_action,
                name: action.EnquiryList.name,
                email: action.EnquiryList.email,
                tel: action.EnquiryList.tel,
                have_missed_call:
                    action.EnquiryList.have_missed_call.toString(),
                have_voice_message:
                    action.EnquiryList.have_voice_message.toString(),
                voice_message: action.EnquiryList.voice_message,
                get_back_date: moment.utc(action.EnquiryList.get_back_date),
                enquiryImage: fileData,
                enquiry_id: action.EnquiryList.enquiry_id,
                area_id: action.EnquiryList.area_id.toString(),
                clearing_date: moment.utc(action.EnquiryList.clearing_date),
                reply_date: moment.utc(action.EnquiryList.reply_date),
            };
        case "@@enquiryFormInfoState/ChangeMissCallRadioAction":
            return {
                ...state,
                have_missed_call: action.have_missed_call,
            };

        case "@@enquiryFormInfoState/ChangeHaveVoiceMessageRadioAction":
            return {
                ...state,
                have_voice_message: action.have_voice_message,
            };

        case "@@enquiryFormInfoState/ChangeVoiceMessageTextAction":
            return {
                ...state,
                voice_message: action.voice_message,
            };

        case "@@enquiryFormInfoState/ChangeGetBackDateAction":
            return {
                ...state,
                get_back_date: action.date,
            };

        case "@@enquiryFormInfoState/ChangeIsInpectedAction":
            return {
                ...state,
                is_inspected: action.is_inspected,
            };

        case "@@enquiryFormInfoState/ChangeHandleDate":
            return {
                ...state,
                handle_date: action.date,
            };

        case "@@enquiryFormInfoState/ChangeClearingDate":
            return {
                ...state,
                clearing_date: action.date,
            };

        case "@@enquiryFormInfoState/ChangeReplyDateAction":
            return {
                ...state,
                reply_date: action.date,
            };

        case "@@enquiryFormInfoState/ChangeResultAction":
            return {
                ...state,
                result: action.result,
            };

        case "@@enquiryFormInfoState/ChangeEmailAction":
            return {
                ...state,
                email: action.email,
            };

        case "@@enquiryFormInfoState/ChangeNameAction":
            return {
                ...state,
                name: action.name,
            };

        case "@@enquiryFormInfoState/ChangeTelAction":
            return {
                ...state,
                tel: action.tel,
            };

        case "@@enquiryFormInfoState/ChangeDisclaimerAction":
            return {
                ...state,
                disclaimer: action.disclaimer,
            };
        
        case '@@enquiryFormInfoState/ChangeExcelStartDateAction':
            return {
                ...state,
                excelDownloadStartDate:action.date
            }

        case '@@enquiryFormInfoState/ChangeExcelEndDateAction':
            return{
                ...state,
                excelDownloadEndDate:action.date
            }

        case "@@enquiryFormInfoState/ClearEnquiryFormAction":
            return {
                ...state,
                district_id: "",
                fileList: null,
                selectDate: null,
                selectEnquiry_type_id: "",
                case_no: "",
                binInfo: null,
                area_id: "",
                othersRemark: "",
                is_others: false,
                is_overfilled: false,
                need_inspection: "",
                selectedEnquiry: false,
                enquiryImage: null,
                have_missed_call: "",
                have_voice_message: "",
                voice_message: "",
                get_back_date: null,
                is_inspected: null,
                handle_date: null,
                clearing_date: null,
                reply_date: null,
                result: "",
                name: "",
                email: "",
                tel: null,
                excelDownloadStartDate:null,
                excelDownloadEndDate:null
            };

        default:
            return state;
    }
}
